import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import './FileDropper.scss';

export default function FileDropper({
  accept = [
    'text/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  acceptText = 'Formato de archivo aceptado. Puedes soltarlo',
  rejectText = 'El formato de archivo no se acepta. Solo se aceptan CSV o Excel',
  iddleText = 'Arrastra un CSV o Excel válidos',
  onAccept = () => {},
  onAbort = () => {},
  onError = () => {},
  onDeleteFile = () => {},
  multiple = false,
  ...props
}) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      onAccept(acceptedFiles);
    },
    [onAccept],
  );

  const {
    isDragActive,
    isDragAccept,
    isDragReject,
    getRootProps,
    getInputProps,
  } = useDropzone({
    onDrop,
    multiple: multiple,
    accept: accept,
  });

  return (
    <section className="file-dropper">
      <div {...getRootProps({ className: 'file-dropper__dropzone' })}>
        <input {...getInputProps()} />
        {isDragAccept && (
          <div className="dropzone dropzone--accept">{acceptText}</div>
        )}
        {isDragReject && (
          <div className="dropzone dropzone--reject">{rejectText}</div>
        )}
        {!isDragActive && (
          <div className="dropzone dropzone--idle">{iddleText}</div>
        )}
      </div>
      <aside className="file-dropper__filenames">
        {props.files.map((file) => (
          <div className="file-dropper__filename" key={file.name}>
            {file.name}
            <div
              className="file-dropper__remove-file"
              onClick={(event) => onDeleteFile(file.name)}
            />
          </div>
        ))}
      </aside>
    </section>
  );
}
